import React from "react";
import ModalLayout from "../../../../components/ModalLayout";
import { Box, Typography } from "@mui/material";
import CustomButton from "../../../../components/CustomButton";
import useSWRMutation from "swr/mutation";
import { fetcherPost } from "../../../../../services/fetcher";
import { useAppDispatch } from "../../../../../hooks/useRedux";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../../redux/features/snackbarSlice";
import { useNavigate } from "react-router-dom";

interface Props {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  open: boolean;
  orderId?: string;
}

export default function RemoveTenderModal(props: Props) {
  const { open, setOpen, orderId } = props;

  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { trigger: deleteTenderOffer } = useSWRMutation(
    [`/DriverPriceReq/Remove`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: () => {
        navigate(-1);
      },
    }
  );

  return (
    <ModalLayout open={open} setOpen={setOpen}>
      <Typography textAlign={"center"}>
        آیا از حذف این پیشنهاد کرایه مطمئن هستید؟
      </Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <CustomButton
          onClick={() => {
            deleteTenderOffer({
              id: orderId,
            });
          }}
          flex={1}
          title="بله"
          bgColor="success.main"
          justifyContent="center"
          fSize="16px"
          px="6px"
          py="10px"
          borderRadius="6px"
          // icon2={<DownloadLikeLogin color={"#fff"} />}
        />
        <CustomButton
          onClick={() => setOpen(false)}
          flex={1}
          title="خیر"
          borderColor="error.main"
          bgColor="error.light"
          justifyContent="center"
          fSize="16px"
          textColor="error.main"
          px="6px"
          py="10px"
          borderRadius="6px"
          // icon2={<DownloadLikeLogin color={"#fff"} />}
        />
      </Box>
    </ModalLayout>
  );
}
